export default __webpack_public_path__ + "static/media/shaped-word-clouds.54a0736e.pdf";